import React from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import { PencilIcon } from "../../../../../svg/pencil-Icon";
import useDxCodeMapRefresh from "../../../hooks/useDxCodeMapRefresh";
interface AuthorizationDetailsProps {
  insuranceName?: string;
  dateOfService?: string;
  providerName?: string;
  location?: string;
  primaryIcdCode?: string | string[];
  orderId: string;
  onEditIcdClick?: () => void;
}

export const AuthorizationDetails: React.FC<AuthorizationDetailsProps> = ({
  insuranceName,
  dateOfService,
  providerName,
  location,
  primaryIcdCode = "NA",
  orderId,
  onEditIcdClick,
}) => {
  const { isRefreshing } = useDxCodeMapRefresh();
  const formattedIcdCode = Array.isArray(primaryIcdCode)
    ? primaryIcdCode.join(", ") || "NA"
    : primaryIcdCode;

  return (
    <div className="flex flex-row items-center gap-2">
      <div className="pl-2 text-sm">{`Insurance: ${insuranceName}`}</div>
      <div className="border-l border-primaryGray-14 pl-2 text-sm">{`DOS: ${dateOfService}`}</div>
      <div className="border-l border-primaryGray-14 pl-2 text-sm">{`Provider: ${providerName}`}</div>
      <div className="border-l border-primaryGray-14 pl-2 text-sm">{`Location: ${location}`}</div>
      <div className="flex items-center gap-1 border-l border-primaryGray-14 pl-2 text-sm">
        <span>Primary ICD-10 Code:</span>
        {!isRefreshing && (
          <>
            <span className="text-h12 font-normal leading-h12 text-primaryGray-6">
              {formattedIcdCode}
            </span>
            <PencilIcon
              width={12}
              height={12}
              onClick={onEditIcdClick}
              aria-label="Edit ICD Code"
              className="cursor-pointer transition-transform hover:scale-110"
            />
          </>
        )}
        {isRefreshing && <SpinningLoader />}
      </div>
    </div>
  );
};
export default AuthorizationDetails;
